import { toast } from "react-toastify";
import { PopUp } from "./tost";
import { clearBookingMgmtSessionUi } from "../Pages/BookingManagement/bookingListSessionUi";

let invalidSessionActive = false;

const PUBLIC_PATHS = new Set([
  "/",
  "/login",
  "/register",
  "/forgot-password",
  "/otpverification",
  "/resetpassword",
  "/addbank",
  "/sign-up-vendor",
  "/finish-signup",
]);

function currentPath() {
  return String(window.location.pathname || "/")
    .replace(/\/+$/, "")
    .toLowerCase() || "/";
}

export function isPublicAuthPage() {
  return PUBLIC_PATHS.has(currentPath());
}

export function isInvalidTokenMessage(message) {
  const text = String(message || "").toLowerCase();
  return (
    text.includes("token is invalid") ||
    text.includes("invalid token") ||
    text.includes("token invalid")
  );
}

export function isInvalidSessionActive() {
  return invalidSessionActive;
}

export function apiErrorMessage(result) {
  const data = result?.response?.data ?? result?.data;
  if (!data || typeof data !== "object") return "";
  return String(data.errorMessage || data.message || "").trim();
}

/** One invalid-token popup for every vendor module. Later calls do nothing. */
export function notifyInvalidToken(message) {
  if (invalidSessionActive || isPublicAuthPage()) return false;
  invalidSessionActive = true;
  const text = String(message || "").trim() || "Your token is invalid!";
  PopUp(text, "", "error").then(() => {
    clearBookingMgmtSessionUi();
    localStorage.clear();
    window.location.assign("/");
  });
  return true;
}

export function notifyInvalidTokenFromApi(result) {
  const message = apiErrorMessage(result);
  if (!isInvalidTokenMessage(message)) return false;
  return notifyInvalidToken(message);
}

const originalToastError = toast.error.bind(toast);
toast.error = (content, options) => {
  const text = typeof content === "string" ? content : "";
  if (!isPublicAuthPage() && (invalidSessionActive || isInvalidTokenMessage(text))) {
    if (isInvalidTokenMessage(text)) notifyInvalidToken(text);
    return undefined;
  }
  return originalToastError(content, options);
};
